import { Helmet } from "react-helmet-async";

// Per-page SEO component. Wraps react-helmet-async and provides sensible
// defaults so each page only needs to override what's different.
//
// Critical baseline meta (default title, description, OG, JSON-LD) also lives
// statically in public/index.html so crawlers/bots that don't execute JS
// (LinkedIn, Facebook, Twitter, Slack, Bing, smaller search engines) see the
// site fully described on first byte.

const SITE = "https://www.vittaniti.com";
const DEFAULT_TITLE = "Vittaniti — Bookkeeping Services USA & Offshore Accounting from India";
const DEFAULT_DESC =
    "Vittaniti Shared Solutions delivers bookkeeping services, outsourced CPA support and remote back-office teams from India to SMEs across the United States and Europe.";
const DEFAULT_OG_IMAGE = `${SITE}/favicon-512x512.png`;

export default function Seo({
    title,
    description,
    path = "/",
    image,
    keywords,
    noindex = false,
    children,
}) {
    const fullTitle = title
        ? `${title} | Vittaniti`
        : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = `${SITE}${path === "/" ? "" : path}`;
    const ogImg = image || DEFAULT_OG_IMAGE;

    return (
        <Helmet prioritizeSeoTags>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}

            {/* Open Graph */}
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={ogImg} />
            <meta property="og:site_name" content="Vittaniti Shared Solutions" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={ogImg} />

            {children}
        </Helmet>
    );
}
